"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAdjustParams = exports.useAdjustParamsCheckInfo = void 0;
const react_1 = require("react");
const lodash_1 = require("lodash");
const interfaces_1 = require("./interfaces");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const apis_1 = require("./apis");
const trade_utils_lib_1 = require("trade_utils_lib");
const GridV4FuturesProcessor_1 = require("./GridV4FuturesProcessor");
const parseParamsToRequest = (_params) => {
    if (!_params.open_price || !Number(_params.open_price)) {
        throw { code: -1, message: "no open price" };
    }
    const req = Object.assign(Object.assign({}, _params), { open_price: _params.open_price, quote_investment: _params.quote_investment || "0" });
    return req;
};
const queryAPI = (request, precision) => {
    return (0, apis_1.adjustParamsCheckAPI)(request).pipe((0, operators_1.map)((res) => {
        const value = Object.assign(Object.assign({}, res), { estimate_investment: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(res.estimate_investment, precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL), estimate_extra_margin: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(res.estimate_extra_margin, precision), min_investment: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(res.min_investment, precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL), max_investment: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(res.max_investment, precision) });
        if (new trade_utils_lib_1.SafeDecimal(value.min_investment).greaterThan(new trade_utils_lib_1.SafeDecimal(value.max_investment))) {
            if (
            // 加仓额度不足时:
            // 当不是调整区间时 - 直接报错
            // 当是调整区间时 - 当estimate_investment 或者 estimate_extra_margin不为0表示需要加仓，但此时又没有加仓额度，则报错
            request.type !== interfaces_1.AdjustParamsType.adjust_params ||
                (request.type === interfaces_1.AdjustParamsType.adjust_params &&
                    res.check_result &&
                    (!new trade_utils_lib_1.SafeDecimal(value.estimate_investment).eq(0) || !new trade_utils_lib_1.SafeDecimal(value.estimate_extra_margin).eq(0)))) {
                value.check_result = false;
                value.reason = interfaces_1.AdjustParamsCheckReason.NO_ADD_POSITION_QUOTA;
            }
        }
        return value;
    }));
};
exports.checkAdjustParams = queryAPI;
const useAdjustParamsCheckInfo = (params) => {
    const [checkInfo, setCheckInfo] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const { open_price, quote_investment, extra_margin, orderId, type, top, bottom, row, extra_margin_amount, is_recommend, is_reinvest } = params;
    const depsExPrice = [type, orderId, quote_investment, extra_margin, top, bottom, row, extra_margin_amount, is_recommend, is_reinvest];
    const requestRef = (0, react_1.useRef)(params);
    requestRef.current = params;
    const [previousPrice, setPreviousPrice] = (0, react_1.useState)(open_price);
    const debounceFn = (0, react_1.useRef)((0, lodash_1.debounce)(() => {
        if (requestRef.current.type === interfaces_1.AdjustParamsType.adjust_params) {
            if (!requestRef.current.top || new trade_utils_lib_1.SafeDecimal(requestRef.current.top).lte(0)) {
                return;
            }
            if (!requestRef.current.bottom || new trade_utils_lib_1.SafeDecimal(requestRef.current.bottom).lte(0)) {
                return;
            }
            if (new trade_utils_lib_1.SafeDecimal(requestRef.current.top).lt(new trade_utils_lib_1.SafeDecimal(requestRef.current.bottom))) {
                return;
            }
            if (!requestRef.current.row ||
                !Number(requestRef.current.row) ||
                new trade_utils_lib_1.SafeDecimal(requestRef.current.row).gt(GridV4FuturesProcessor_1.GridV4FuturesMaxGrids) ||
                new trade_utils_lib_1.SafeDecimal(requestRef.current.row).lt(GridV4FuturesProcessor_1.GridV4FuturesMinGrids)) {
                return;
            }
        }
        const sub = (0, rxjs_1.of)(requestRef.current)
            .pipe((0, operators_1.map)((reqOp) => {
            return parseParamsToRequest(reqOp);
        }), (0, operators_1.mergeMap)((req) => {
            setLoading(true);
            return queryAPI(req, requestRef.current.precision).pipe((0, operators_1.catchError)((error) => {
                const newReq = Object.assign(Object.assign({}, req), { quote_investment: "0" });
                return queryAPI(newReq, requestRef.current.precision);
            }));
        }))
            .subscribe({
            next: (data) => {
                setCheckInfo(data);
                setLoading(false);
                setPreviousPrice(requestRef.current.open_price);
            },
            error: (error) => {
                setLoading(false);
                console.log(`useAdjustParamsCheckInfo debounce: ${JSON.stringify(error)}`);
            },
        });
        return sub;
    }, 500));
    // 用户输入防抖
    (0, react_1.useEffect)(() => {
        var _a;
        const sub = (_a = debounceFn.current) === null || _a === void 0 ? void 0 : _a.call(debounceFn);
        return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, depsExPrice);
    const throttleDepensOnPriceFn = (0, react_1.useRef)((0, lodash_1.throttle)(() => {
        const request = parseParamsToRequest(requestRef.current);
        const sub = queryAPI(request, requestRef.current.precision)
            .pipe((0, operators_1.catchError)((error) => {
            const newReq = Object.assign(Object.assign({}, request), { quote_investment: "0" });
            return queryAPI(newReq, requestRef.current.precision);
        }))
            .subscribe({
            next: (data) => {
                setCheckInfo(data);
                setPreviousPrice(requestRef.current.open_price);
            },
            error: (error) => {
                console.log(`useAdjustParamsCheckInfo throttle: ${JSON.stringify(error)}`);
            },
        });
        return sub;
    }, 5000));
    // 当前价格变更节流
    (0, react_1.useEffect)(() => {
        var _a;
        // 只有在当前参数合理时，才去根据价格刷新数据
        if (!checkInfo || !checkInfo.check_result) {
            return;
        }
        if (!Number(quote_investment) || // 没有投资额
            !Number(checkInfo.min_investment) || // 没有最小投资额
            !Number(checkInfo.max_investment) || // 没有最大投资额
            Number(quote_investment) < Number(checkInfo.min_investment) || // 小于最小投资额
            Number(quote_investment) > Number(checkInfo.max_investment) // 大于最大投资额
        ) {
            return;
        }
        const sub = (_a = throttleDepensOnPriceFn.current) === null || _a === void 0 ? void 0 : _a.call(throttleDepensOnPriceFn);
        return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open_price]);
    const queryCheckInfo = (0, react_1.useCallback)((investParam) => {
        if (investParam) {
            const p = Object.assign(Object.assign({}, requestRef.current), { quote_investment: investParam });
            requestRef.current = p;
        }
        const request = parseParamsToRequest(requestRef.current);
        return queryAPI(request, requestRef.current.precision).pipe((0, operators_1.tap)((value) => {
            setCheckInfo(value);
            setPreviousPrice(requestRef.current.open_price);
        }));
    }, []);
    // 目前仅用于修改区间时需要根据追加投资额，最新价格来更新checkInfo的信息
    // ToDo: 修干传参方式为Object
    const queryCheckInfoWithExtraInfo = (0, react_1.useCallback)((investParam, extraMarginAmountParam, openPrice, isRecommend, isReinvest, isAdjust) => {
        const p = Object.assign(Object.assign({}, requestRef.current), { quote_investment: investParam || "0", extra_margin_amount: extraMarginAmountParam || "0", open_price: openPrice, is_recommend: isRecommend, is_reinvest: isReinvest });
        requestRef.current = p;
        const request = parseParamsToRequest(requestRef.current);
        return queryAPI(request, requestRef.current.precision).pipe((0, operators_1.tap)((value) => {
            setCheckInfo(value);
            setPreviousPrice(requestRef.current.open_price);
        }));
    }, []);
    return { checkInfo, queryCheckInfo, queryCheckInfoWithExtraInfo, loading: loading, previousPrice };
};
exports.useAdjustParamsCheckInfo = useAdjustParamsCheckInfo;
